//export const udata= { user: {username:'ramenpepe', id:'985504983' } }
export const udata = window.Telegram.WebApp.initDataUnsafe;